const SDK_VERSION = "10.64.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
